import { render, staticRenderFns } from "./MaestroDocumentos.vue?vue&type=template&id=7f82ca50&"
import script from "./MaestroDocumentos.vue?vue&type=script&lang=js&"
export * from "./MaestroDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports